import {
  Box,
  CardContent,
  FormControl,
  Grid,
} from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";
import CustomFormLabel from "../../../../components/forms/custom-elements/CustomFormLabel";
import CustomTextField from "../../../../components/forms/custom-elements/CustomTextField";

export const AddCV = () => {
  const captureForm = useFormikContext();

  return (
    <Box>
      <FormControl sx={{ width: "100%" }}>
        <Box sx={{ ml: 0, mt: 0 }}>
          <CardContent
            sx={{
              padding: "10px 30px 10px 30px",
            }}
          >
            <Grid container spacing={2}>
              {/* First Name */}
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CustomFormLabel htmlFor="firstName">
                  First Name
                </CustomFormLabel>

                <CustomTextField
                  type="text"
                  id="firstName"
                  name="firstName"
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Enter first name"
                  {...captureForm.getFieldProps("firstName")}
                  error={Boolean(
                    captureForm.touched?.firstName &&
                      captureForm.errors?.firstName
                  )}
                  helperText={
                    captureForm.touched?.firstName &&
                    captureForm.errors?.firstName
                  }
                />
              </Grid>

              {/* Middle Name */}
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CustomFormLabel htmlFor="middleName">
                  Middle Name
                </CustomFormLabel>

                <CustomTextField
                  type="text"
                  id="middleName"
                  name="middleName"
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Enter middle name"
                  {...captureForm.getFieldProps("middleName")}
                  error={Boolean(
                    captureForm.touched?.middleName &&
                      captureForm.errors?.middleName
                  )}
                  helperText={
                    captureForm.touched?.middleName &&
                    captureForm.errors?.middleName
                  }
                />
              </Grid>

              {/* Last Name */}
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CustomFormLabel htmlFor="lastName">
                  Last Name
                </CustomFormLabel>

                <CustomTextField
                  type="text"
                  id="lastName"
                  name="lastName"
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Enter last name"
                  {...captureForm.getFieldProps("lastName")}
                  error={Boolean(
                    captureForm.touched?.lastName &&
                      captureForm.errors?.lastName
                  )}
                  helperText={
                    captureForm.touched?.lastName &&
                    captureForm.errors?.lastName
                  }
                />
              </Grid>

              {/* Education */}
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <CustomFormLabel htmlFor="education">
                  Education
                </CustomFormLabel>

                <CustomTextField
                  type="text"
                  id="education"
                  name="education"
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Example: B.Tech Electrical Engineering"
                  {...captureForm.getFieldProps("education")}
                  error={Boolean(
                    captureForm.touched?.education &&
                      captureForm.errors?.education
                  )}
                  helperText={
                    captureForm.touched?.education &&
                    captureForm.errors?.education
                  }
                />
              </Grid>

              {/* Experience */}
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <CustomFormLabel htmlFor="experience">
                  Experience
                </CustomFormLabel>

                <CustomTextField
                  type="text"
                  id="experience"
                  name="experience"
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Example: 2 Years or Fresher"
                  {...captureForm.getFieldProps("experience")}
                  error={Boolean(
                    captureForm.touched?.experience &&
                      captureForm.errors?.experience
                  )}
                  helperText={
                    captureForm.touched?.experience &&
                    captureForm.errors?.experience
                  }
                />
              </Grid>

              {/* Contact Number */}
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <CustomFormLabel htmlFor="contact">
                  Contact Number
                </CustomFormLabel>

                <CustomTextField
                  type="text"
                  id="contact"
                  name="contact"
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Enter 10 digit contact number"
                  value={captureForm.values.contact || ""}
                  inputProps={{
                    maxLength: 10,
                    inputMode: "numeric",
                  }}
                  onChange={(event) => {
                    const numericValue = event.target.value.replace(
                      /[^0-9]/g,
                      ""
                    );

                    captureForm.setFieldValue(
                      "contact",
                      numericValue.slice(0, 10)
                    );
                  }}
                  onBlur={() =>
                    captureForm.setFieldTouched("contact", true)
                  }
                  error={Boolean(
                    captureForm.touched?.contact &&
                      captureForm.errors?.contact
                  )}
                  helperText={
                    captureForm.touched?.contact &&
                    captureForm.errors?.contact
                  }
                />
              </Grid>

              {/* Attachment */}
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <CustomFormLabel htmlFor="cv">
                  Attachment
                </CustomFormLabel>

                <CustomTextField
                  id="cv"
                  name="cv"
                  variant="outlined"
                  fullWidth
                  size="small"
                  type="file"
                  inputProps={{
                    accept: ".pdf,.doc,.docx",
                  }}
                  onChange={(event) => {
                    const file =
                      event.currentTarget.files?.[0] || null;

                    captureForm.setFieldValue("cv", file);
                  }}
                  onBlur={() =>
                    captureForm.setFieldTouched("cv", true)
                  }
                  error={Boolean(
                    captureForm.touched?.cv &&
                      captureForm.errors?.cv
                  )}
                  helperText={
                    captureForm.touched?.cv &&
                    captureForm.errors?.cv
                  }
                />
              </Grid>

              {/* Remarks */}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <CustomFormLabel htmlFor="remarks">
                  Remarks
                </CustomFormLabel>

                <CustomTextField
                  id="remarks"
                  name="remarks"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={3}
                  placeholder="Enter candidate remarks"
                  {...captureForm.getFieldProps("remarks")}
                  error={Boolean(
                    captureForm.touched?.remarks &&
                      captureForm.errors?.remarks
                  )}
                  helperText={
                    captureForm.touched?.remarks &&
                    captureForm.errors?.remarks
                  }
                />
              </Grid>
            </Grid>
          </CardContent>
        </Box>
      </FormControl>
    </Box>
  );
};
